/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlExperianTradeDBT
 */
export interface ControlExperianTradeDBT {
    /**
     * 
     * @type {number}
     * @memberof ControlExperianTradeDBT
     */
    q_one: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExperianTradeDBT
     */
    q_two: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExperianTradeDBT
     */
    q_three: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExperianTradeDBT
     */
    q_four: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExperianTradeDBT
     */
    q_five: number;
}

/**
 * Check if a given object implements the ControlExperianTradeDBT interface.
 */
export function instanceOfControlExperianTradeDBT(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "q_one" in value;
    isInstance = isInstance && "q_two" in value;
    isInstance = isInstance && "q_three" in value;
    isInstance = isInstance && "q_four" in value;
    isInstance = isInstance && "q_five" in value;

    return isInstance;
}

export function ControlExperianTradeDBTFromJSON(json: any): ControlExperianTradeDBT {
    return ControlExperianTradeDBTFromJSONTyped(json, false);
}

export function ControlExperianTradeDBTFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlExperianTradeDBT {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'q_one': json['q_one'],
        'q_two': json['q_two'],
        'q_three': json['q_three'],
        'q_four': json['q_four'],
        'q_five': json['q_five'],
    };
}

export function ControlExperianTradeDBTToJSON(value?: ControlExperianTradeDBT | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'q_one': value.q_one,
        'q_two': value.q_two,
        'q_three': value.q_three,
        'q_four': value.q_four,
        'q_five': value.q_five,
    };
}

